import FieldConfig from "../../../proto/field-config"
import FieldUsers from "../../../generic/users/users"
import Project from "../../../../model2/project/project"
import FieldTaskReportedByUsers_TableCell from "../../task/reported-by-users/render/table/table-cell"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"

export default class FieldProjectReportedByUsers extends FieldUsers {

    constructor(config:FieldConfig) {
        super(config);

        this.icon       = 'i5-users'
        this.label      = 'Reported by users'

        this.hasCalculatedValues                    = true
        this.renderComponents.tableCell             = FieldTaskReportedByUsers_TableCell
        this.renderComponents.tableCellCalculated   = FieldTaskReportedByUsers_TableCell
    }

    canEdit(model: Project):boolean {
        return false
    }

    getDefaultAggregateFunction(): AggregateFunctionType {
        return AggregateFunctionType.USERS_UNION
    }
}
